export const numberFormat = (number, decimals = 0) => {
    const locale = document.documentElement.lang;
    const formatterObj = new Intl.NumberFormat(locale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    return formatterObj.format(number);
}
